{
  "related to": "This resource is related to another resource in an undefined way",
  "profiles": "This database shares a portion of data with another database",
  "extends": "This resource extends or builds upon another resource",
  "deprecates": "The linked resource has been retired as it is no longer active or actively maintained",
  "collects": "A Collection can collect Standards, Databases and Data Policies based on a project, initiative or infrastructure",
  "recommends": "A standard or database can be recommended by a data policy",
  "implements": "This database implements a particular standard",
  "shares data with": "This database shares a portion of data with another database",
  "shares code with": "This database shares a portion of code with another database",
  "accepts": "This database accepts data that follows a particular standard",
  "outputs": "This database outputs data that follows a particular standard",
  "measures principle": "Used to show which 'owning' principle any given metric belongs to",
  "part of": "Allows composition of metrics within other metrics, or shows what 'parent' principle a principle bleongs to"
}
